import React from 'react';
import Link from 'next/link';
import classnames from 'classnames/bind';
import projectLogo from '../../assets/images/footer-logo.svg';
import gridLogo from '../../assets/images/griddynamics-logo.svg';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import styles from './PageFooter.module.scss';
import { IconButton } from '@mui/material';
import { Typography } from 'gd-design-library';
import packageJson from '../../package.json';
import { PARTNER_BANNER_OPTIONS, PARTNERS, promoLinks, ROUTES } from '@constants';
const CN = 'page-footer';
const cx = classnames.bind(styles);

const contentClassName = `${CN}__content`;
const projectLogoClassName = `${CN}__project-logo`;
const gridLogoClassName = `${CN}__grid-logo`;
const linksClassName = `${CN}__links`;
const socialMediaClassName = `${CN}__social-media`;
const disclaimerClassName = `${CN}__disclaimer`;
const promoLinkClassName = `${CN}__promo-link`;

const socialIcons = [ <FacebookIcon key='facebook' />,
  <XIcon key='x-logo' />,
  <LinkedInIcon key='linkedin' />,
  <YouTubeIcon key='youtube' /> ];

export const PageFooter: React.FC = () => {

  const poweredBy = (): string | null => {
    switch (true) {
    case PARTNERS.includes(PARTNER_BANNER_OPTIONS.AWS):
      return ' powered by AWS';
    case PARTNERS.includes(PARTNER_BANNER_OPTIONS.GCP):
      return ' powered by Google Cloud';
    default: return null;
    }
  };

  return (
    <footer className={ cx(CN) }>
      <div className={ cx(contentClassName) }>
        <div className={ cx(projectLogoClassName) }>
          <Link href='/'>
            <img src={ projectLogo.src } alt='Project logo' />
          </Link>
          <Typography>{`App version ${packageJson.version}`}</Typography>
        </div>
        <div className={ cx(gridLogoClassName) }>
          <img src={ gridLogo.src } alt='Griddynamics logo' />
          <Typography>{`© Grid Dynamics, ${new Date().getFullYear()}. All Rights Reserved`}</Typography>
        </div>
        <div className={ cx(linksClassName) }>
          {promoLinks.map(promoLink => (
            <Link
              key={ promoLink.url }
              className={ cx(promoLinkClassName) }
              href={ promoLink.url }
              target='_blank'
              rel='noreferrer'
            >
              <Typography as='span'>{promoLink.name}</Typography>
            </Link>
          ))}
          <Link href={ ROUTES.rcsTestDevices }>
            <Typography as='span'>RCS Test Devices</Typography>
          </Link>
          <Link href={ ROUTES.registerRcsTestDevice }>
            <Typography as='span'>Register RCS test device</Typography>
          </Link>
        </div>
        <div className={ cx(disclaimerClassName) }>
          <ul className={ cx(socialMediaClassName) }>
            {socialIcons.map(icon => (
              <li key={ icon.key }>
                <IconButton>{icon}</IconButton>
              </li>
            ))}
          </ul>
          <Typography>
            {`The Accelerator Store${poweredBy()} is a demo application. `}
          All content displayed is fictitious and for demonstration purposes only.
          </Typography>
        </div>
      </div>
    </footer>
  );
};
